import HomeActionTypes from './home.types';


export const homeSyncStart = payload => ({
    type: HomeActionTypes.HOME_SYNC_START,
    payload
});

export const homeSyncFinish = payload => ({
    type: HomeActionTypes.HOME_SYNC_FINISH,
    payload
});

export const validateCode = payload => ({
    type: HomeActionTypes.VALIDATE_CODE,
    payload
});
